import React from 'react';
//import { Link } from "react-router-dom";
import axios from "axios";
//import {Redirect} from 'react-router-dom';
import logoreg from "../abc.png"
import Path from "./config";
import Btn from "./btn"
import Btnfive from './btnfive';
class Payment extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            sbg_mobile_no: "",
            sbg_email_id: "",
            checked: true,
            ishundread: true,
            amount: '',
            instructions: '',
            suchi_curier_fee: '',
            suchi_fee_status: '',
            suchi_nondani_fee: '',
            suchi_suchi_fee: '',
            suchi_suchifee_status: '',
            feeType: 'nondani'

        }

    }
    componentDidMount() {
        if (localStorage.getItem("show#doc12") === "Yes") {
            this.props.history.push(`/FormProfile`);
        }
        axios.get(Path + 'suchi_instruction.php')
            .then(function (response) {
                this.setState({ instructions: response.data.business_table[0].paymeni_instruction })

            }.bind(this))
            .catch(function (error) {
                // handle error
                console.log(error);
            })
            .then(function () {
                // always executed
            });
        axios.get(Path + 'suchi_fee_manage_view.php')
            .then(function (response) {
                this.setState({
                    suchi_curier_fee: response.data.suchi_curier_fee,
                    suchi_fee_status: response.data.suchi_fee_status,
                    suchi_nondani_fee: response.data.suchi_nondani_fee,
                    suchi_suchi_fee: response.data.suchi_suchi_fee,
                    suchi_suchifee_status: response.data.suchi_suchifee_status,
                    amount: response.data.suchi_nondani_fee
                })
            }.bind(this))
            .catch(function (error) {
                // handle error
                console.log(error);
            })
            .then(function () {
                // always executed
            });
    }
    handleCheckboxChange = (event) => {
        //console.log("aaa",event.target.checked) 

        this.setState({ checked: event.target.checked }, () => {
            // console.log(event.target.checked) 
            if (this.state.checked !== true) {
                this.setState({ ishundread: true, feeType: 'nondani', amount: this.state.suchi_nondani_fee })
            }
            else {
                let tot = parseInt(this.state.amount) + parseInt(this.state.suchi_suchi_fee)

                this.setState({ ishundread: false, feeType: 'suchiNondani', amount: tot })
            }
        }
        )
    }
    payNowHandler = (e) => {
        //  console.log("this.state.feeType", this.state.feeType)
        this.handlePay(e, this.state.amount, this.state.feeType, this.state.suchi_suchi_fee, this.state.suchi_nondani_fee)
    }
    handlePay = async (e, amt, feeType, suchi_suchi_fee, suchi_nondani_fee) => {
        let orderIdCreate = "sbg_payment_amount=" + amt +
            "&sbg_id=" + localStorage.getItem("userId");

        axios.post(Path + `razorpay-php-testapp-master/pay.php?` + orderIdCreate)
            .then((response) => {
                // console.log(response);
                if (response.data) {
                    var options = {
                        key: "rzp_live_4LEZFaBCGTkOTY", // Enter the Key ID generated from the Dashboard
                        amount: 1 * 100, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
                        currency: "INR",
                        name: "Leva Shubhmangal Pustak Suchi", //your business name
                        description: "Thank You",
                        order_id: response.data.id,
                        image: '',
                        handler: async function (response) {
                            //console.log(response);
                            if (response.razorpay_payment_id) {
                                console.log(response)
                                let typee = "Payment";


                                try {
                                    let tempStr = "sbg_payment_amount=" + amt +
                                        "&sbg_id=" + localStorage.getItem("userId") +
                                        "&type=" + typee +
                                        "&feeType=" + feeType +
                                        "&suchi_suchi_fee=" + suchi_suchi_fee +
                                        "&suchi_nondani_fee=" + suchi_nondani_fee +
                                        "&razorpay_payment_id=" + response.razorpay_payment_id;

                                    axios.post(Path + `Suchi_Bride_Groom_update.php?` + tempStr)
                                        .then((response) => {
                                            //  console.log(response);
                                            if (response.data.status === "updated") {
                                                //  window.location.reload(false);
                                                localStorage.setItem("show#doc12", "Yes");
                                                window.location.reload(false);
                                                //   window.location.replace(`./FormProfileNew`);
                                            } else {
                                                alert("Payment not Received");
                                            }
                                        });
                                } catch (error) {
                                    console.error(error);
                                    // Handle the error here
                                }
                            }
                        },
                        prefill: {
                            name: ' Suchi User', //your customer's name
                            email: '',
                            contact: '',
                        },
                        modal: {
                            ondismiss() {
                                // Handle what happens when the customer dismisses the payment form without completing the payment. This may
                                // involve re-enabling a "pay now" button if you disable it when it's clicked.
                                //  window.location.replace("/FormProfileNew/SummaryDetails");
                            },
                        },
                        notes: {
                            address: "Razorpay Corporate Office",
                        },
                        theme: {
                            color: "#3399cc",
                        },
                    };
                    var rzp1 = new window.Razorpay(options);
                    rzp1.open();
                    rzp1.on("payment.failed", function (response) {
                        // razorpay_payment_id
                        localStorage.setItem("bf_payment_status", "Unpaid");
                        this.props.history.push(`/FormProfileNew/SummaryDetails`);
                    });
                } else {
                    alert("Payment not Received");
                }
            });



    }
    render() {

        return (
            <>
                <div className="container-fluid">
                    <span className="align-middle d-flex justify-content-center"><img src={logoreg} alt="logo" style={{ width: "300px" }}></img></span>
                    <div className="row justify-content-md-center my-2 ">
                        <div className="col-md-6 border  border-5 p-3 mb-2 text-primary">
                            <h4>अति महत्वाची सूचना </h4>
                            <div dangerouslySetInnerHTML={{ __html: this.state.instructions }} />
                        </div>
                    </div>
                    <div className="row justify-content-md-center my-3 ">

                        <div className="col-md-5 border  border-5 p-3 mb-2 bg-light text-dark">
                            <div className="mb-3  ">
                                <span className="d-block p-2 bg-danger text-white text-md-center text-capitalize">पेमेंट पेज</span>
                            </div>
                            <div className="mb-3  ">
                                <div className="row">
                                    <div className="col font-weight-bold">
                                        सूची नोंदणी फी
                                    </div>
                                    <div className="col font-weight-bold">
                                        <input type="text" value={this.state.suchi_nondani_fee} disabled className="text-center font-weight-bold" style={{ width: "70px" }} />
                                    </div>
                                    <div className="col">
                                        <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked" checked readOnly />

                                    </div>
                                </div>
                                {this.state.suchi_fee_status === '1' ?
                                    <div className="row mt-4">
                                        <div className="col font-weight-bold">
                                            सूची फी (Optional)<br></br>

                                        </div>
                                        <div className="col">
                                            <input type="text" value={this.state.suchi_suchi_fee} disabled className="text-center font-weight-bold" style={{ width: "70px" }} />
                                        </div>
                                        <div className="col">
                                            <input className="form-check-input" type="checkbox" value={this.state.checked}
                                                onChange={this.handleCheckboxChange} id="flexCheckChecked1" />

                                        </div>
                                    </div> : ''}

                                <div className="row mt-4">
                                    <div className="col ">
                                        {this.state.suchi_suchifee_status}
                                    </div></div>
                                <hr></hr>
                                <div className="row mt-4">
                                    <div className="col font-weight-bold">
                                        <h4> एकूण रक्कम </h4>
                                    </div>
                                    <div className="col text-primary font-weight-bolder">
                                        <h4>{this.state.amount}     </h4>
                                    </div>
                                    <div className="col">
                                    </div>
                                </div>
                                <div className="row mt-4 pl-5 text-center">
                                    <div className="col">
                                        <button className='payNowBtn' onClick={(e) => this.payNowHandler(e)}>Proceed To Pay</button>
                                        {/* <Btn/> */}
                                        {/* {this.state.ishundread ? <Btn /> : <Btnfive />} */}
                                    </div>
                                </div>
                                <br></br>पेमेंट यशस्वी झाल्यावर नोंदणी फॉर्म येण्यासाठी थोडं थांबावं तरीही नोंदणी फॉर्म न उघडल्यास पेमेंट झाल्याचा स्क्रीन शॉट सोबत वधू-वराचे पूर्ण नाव 9730550506  या नंबर वर पाठवून एक कॉल करून कळवावे.
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default Payment

